import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Leaflet je součástí buildu (dřív se tahal z unpkg.com — blokátory a firemní
// proxy ho zabíjely a mapa se pak nikdy nezobrazila).
export function MapView({ lat, lng, points, height = 200, zoom = 15 }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const markers = points && points.length ? points : (lat != null && lng != null ? [{ lat, lng }] : []);
    const center = markers.length ? [markers[0].lat, markers[0].lng] : [50.0755, 14.4378];

    if (!mapRef.current) {
      mapRef.current = L.map(ref.current, { zoomControl: true, attributionControl: false }).setView(center, zoom);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(mapRef.current);
    }
    const map = mapRef.current;
    map._proyektyMarkers?.forEach((m) => map.removeLayer(m));
    map._proyektyMarkers = [];
    const icon = L.divIcon({
      className: "",
      html: '<div style="width:20px;height:20px;background:#e0703f;border:3px solid #fff;border-radius:50%;box-shadow:0 0 0 1px rgba(0,0,0,.3)"></div>',
      iconSize: [20, 20], iconAnchor: [10, 10],
    });
    markers.forEach((p) => {
      if (p.lat == null || p.lng == null) return;
      const m = L.marker([p.lat, p.lng], { icon }).addTo(map);
      if (p.label) m.bindPopup(p.label);
      map._proyektyMarkers.push(m);
    });
    if (markers.length > 1) {
      map.fitBounds(markers.map((p) => [p.lat, p.lng]), { padding: [30, 30] });
    } else if (markers.length === 1) {
      map.setView([markers[0].lat, markers[0].lng], zoom);
    }
    setTimeout(() => map.invalidateSize(), 100);
  }, [lat, lng, JSON.stringify(points), zoom]);

  useEffect(() => () => { mapRef.current?.remove(); mapRef.current = null; }, []);

  return <div ref={ref} data-testid="map-view" style={{ height, width: "100%" }} className="border border-border rounded-[20px] overflow-hidden" />;
}
